import React, { useState } from 'react';
import TextField from '../../Form/TextField';
import {
    EuiButton,
    EuiFlexItem,
    EuiCopy,
    EuiText,
    EuiSpacer,
    EuiFlyout,
    EuiFlyoutHeader,
    EuiFlyoutBody,
    EuiTitle,
} from '@elastic/eui';
import FormGroupDescription from '../../formGroupDescription';
import ButtonGroup from '../../Form/ButtonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { requestForRiderService } from '../../../api/requestThirdPartyRiderService';
import { getOutletDetails } from '../../../api/outlet/getOutletDetails';

const LoadShareRider = () => {
    const {
        formState: { errors },
        control,
        watch,
        setValue,
    } = useFormContext();
    const outletId = useSelector((state) => state.outlet.selectedOutletId);
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);
    const dispatch = useDispatch();
    const outlet = useSelector((state) => state.outlet.selectedOutletDetails);
    const approvalDate = outlet?.third_party_rider_setting?.adlogs_load_share_request?.approval_date;
    const serviceStatus = outlet?.third_party_rider_setting?.adlogs_load_share_request?.status;

    const startService = () => {
        dispatch(requestForRiderService('load_share_al', 'rider service request for LoadShare')).then((res) => {
            dispatch(getOutletDetails(outletId));
        });
    };
    let flyout;

    if (isFlyoutVisible) {
        flyout = (
            <EuiFlyout ownFocus onClose={() => setIsFlyoutVisible(false)} aria-labelledby={'simpleFlyoutTitle'}>
                <EuiFlyoutHeader hasBorder>
                    <EuiTitle size='m'>
                        <h2 id={'simpleFlyoutTitle'}>LoadShare riders</h2>
                    </EuiTitle>
                </EuiFlyoutHeader>
                <EuiFlyoutBody>
                    <ButtonGroup
                        idSelected={watch('is_adlogs_load_share_integration_enabled') ? '1' : '0'}
                        color='primary'
                        control={control}
                        setValue={setValue}
                        name='is_adlogs_load_share_integration_enabled'
                        watch={watch}
                        label={'LoadShare integration'}
                    />

                    {/* {watch('is_adlogs_load_share_integration_enabled') ? (
                        <>
                            <TextField
                                errors={errors}
                                label='LoadShare API Key'
                                name='load_share_api_key'
                                placeholder='Enter LoadShare API Key'
                                rules={{ required: 'Please Enter LoadShare API Key' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='LoadShare Partner Merchant Id'
                                name='load_share_partner_merchant_id'
                                placeholder='Enter LoadShare Partner Merchant Id'
                                rules={{ required: 'Please enter LoadShare Partner Merchant Id' }}
                                control={control}
                            />
                            <TextField
                                errors={errors}
                                label='LoadShare call back URL'
                                name='load_share_call_back_url'
                                placeholder='Enter url'
                                control={control}
                                disabled={true}
                                defaultValue={watch('load_share_call_back_url')}
                                append={
                                    <EuiCopy
                                        textToCopy={watch('load_share_call_back_url') ? watch('load_share_call_back_url') : ''}
                                    >
                                        {(copy) => <EuiText onClick={copy}>Copy</EuiText>}
                                    </EuiCopy>
                                }
                            />
                        </>
                    ) : null} */}
                </EuiFlyoutBody>
            </EuiFlyout>
        );
    }

    return (
        <div style={{ maxWidth: '650px' }}>
            <FormGroupDescription
                title={restaurantDescriptions?.load_share_al_riders?.display_name}
                description={restaurantDescriptions?.load_share_al_riders?.description}
            >
                <EuiFlexItem>
                    <EuiButton
                        style={{
                            backgroundColor: serviceStatus === 'approved' && '#228B22',
                            color: serviceStatus === 'approved' && 'white',
                        }}
                        fill
                        onClick={startService}
                        disabled={serviceStatus ? true : false}
                    >
                        {serviceStatus ? serviceStatus : 'START SERVICE'}
                    </EuiButton>
                </EuiFlexItem>
                <EuiSpacer style={{ marginTop: '6px' }}>
                    <EuiText textAlign='center' size='xs'>
                        ------ OR ------
                    </EuiText>
                </EuiSpacer>
                <EuiFlexItem>
                    <EuiButton onClick={() => setIsFlyoutVisible(true)}>CONNECT ACCOUNT</EuiButton>
                </EuiFlexItem>
                {flyout}
            </FormGroupDescription>
            {serviceStatus === 'pending' && (
                <EuiText
                    style={{
                        padding: '8px 12px',
                        background: '#BBB',
                        color: 'white',
                        marginBottom: '12px',
                        borderRadius: '4px',
                    }}
                >
                    <p> Your reqeust has been received and it shall be activated by {approvalDate} </p>
                </EuiText>
            )}
        </div>
    );
};

export default LoadShareRider;
